const SkeletonItem = () => (
  <div className="projects-list-scroller__item">
    <article className="project-item project-item--horizontal">
      <span className="project-item__link">
        <header className="project-item__header">
          <span className="project-item__media">
            <span className="skeleton__media vtmn-skeleton" />
          </span>
        </header>
      </span>
      <footer className="project-item__body">
        <span className="vp-body-s">
          <span className="skeleton__item vtmn-skeleton" />
        </span>
      </footer>
    </article>
  </div>
);

export const ProjectsListSkeleton = ({ items = 12 }: { items?: number }) => (
  <div
    className="skeleton-template projects-list-skeleton"
    data-testid="projects-list-skeleton"
  >
    <div className="projects-list">
      {Array.from({ length: items }, (_, key) => (
        <SkeletonItem key={key} />
      ))}
    </div>
  </div>
);
